import { AsyncPipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Toast } from '@inera/common';
import { IDAlertModule } from '@inera/ids-angular/components/alert';
import { Observable } from 'rxjs';
import { ToastService } from 'src/app/services/toast.service';
import { HoverDirective } from '../hover.directive';

@Component({
  selector: 'toast-messages',
  standalone: true,
  imports: [IDAlertModule, AsyncPipe, HoverDirective],
  templateUrl: './toast-messages.component.html',
  styleUrls: ['./toast-messages.component.scss'],
})
export class ToastMessagesComponent implements OnInit {
  public toasts$: Observable<Toast[]>;

  constructor(private toastService: ToastService) {}

  ngOnInit(): void {
    this.toasts$ = this.toastService.connect();
  }

  public dismissToast(toast: Toast): void {
    this.toastService.removeToast(toast);
  }

  public swipeAction(action: any, toast: Toast): void {
    if (action === 'swipe-right') {
      this.toastService.removeToast(toast);
    }
  }

  public handleHover(hoverState: any, toast: Toast): void {
    if (hoverState === 'active') {
      this.toastService.killTimer(toast);
    } else {
      this.toastService.resumeTimer(toast);
    }
  }

  public isSingle(value: string | string[]): boolean {
    if (typeof value === 'string') {
      return true;
    } else {
      return false;
    }
  }

  public getType(toast: Toast): string {
    switch (toast.type) {
      case 'danger':
        return 'error';
      case 'warning':
        return 'attention';
      case 'success':
        return 'success';
      default:
        return 'info';
    }
  }
}
